import { render, staticRenderFns } from "./CalendarEventReminders.vue?vue&type=template&id=6bec40d6&scoped=true"
import script from "./CalendarEventReminders.vue?vue&type=script&lang=ts"
export * from "./CalendarEventReminders.vue?vue&type=script&lang=ts"
import style0 from "./CalendarEventReminders.vue?vue&type=style&index=0&id=6bec40d6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bec40d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bec40d6')) {
      api.createRecord('6bec40d6', component.options)
    } else {
      api.reload('6bec40d6', component.options)
    }
    module.hot.accept("./CalendarEventReminders.vue?vue&type=template&id=6bec40d6&scoped=true", function () {
      api.rerender('6bec40d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/CalendarEventReminders.vue"
export default component.exports